var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"mapType"},_vm._l((_vm.mapList),function(item){return _c('li',{key:item.value,class:['item', item.class,{actived: _vm.activedMap === item.value}],on:{"click":function($event){return _vm.changeBasemap(item)}}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }